import styled from "@emotion/styled";
import SkapaTabs, {
  Tab as SkapaTab,
  TabPanel as SkapaTabPanel,
  type TabPanelProps,
  type TabProps,
  type TabsProps,
} from "@ingka/tabs";

export type { TabsProps, TabProps };

export const TabContainer = styled.div`
  padding: 0;
`;

export const Tab = (props: TabProps) => {
  return <SkapaTab prefix="saleslead__" {...props} />;
};

export const TabPanel = (props: TabPanelProps) => {
  return (
    <SkapaTabPanel prefix="saleslead__" {...props}>
      {props.children}
    </SkapaTabPanel>
  );
};

export const Tabs = (props: TabsProps) => {
  return <SkapaTabs prefix="saleslead__" {...props} />;
};
